import { Grid, TextField } from "@mui/material";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../../../utils/Functions";
import CountrySelector from "../../../../components/form/CountrySelector";

const formFields = {
  contact: [
    { title: "email", required: true },
    { title: "phoneNumber", required: true },
  ],
  oib: [{ title: "oib", required: false }],
  location: [
    { title: "address", required: true },
    { title: "province", required: true },
    { title: "city", required: true },
    { title: "place", required: true },
    { title: "zipcode", required: false },
  ],
};

export default function SignUpFormBody({
  location = true,
  oib = true,
  contact = true,
  grid = true,
}) {
  const { register, formState } = useFormContext();
  const { errors } = formState;
  const { t } = useTranslation();

  const renderFields = (fields, mdLength) =>
    fields.map((field, index) => {
      if (grid) {
        return (
          <Grid key={field.title} item md={mdLength} xs={12} sm={12}>
            <TextField
              fullWidth
              name={field.title}
              size="medium"
              label={t(capitalizeFirstLetter(field.title))}
              error={!!errors?.[field.title]}
              helperText={errors?.[field.title]?.message}
              inputProps={{ "data-testid": `auth.signup.${field.title}-input` }}
              {...register(field.title)}
            />
          </Grid>
        );
      } else {
        return (
          <TextField
            fullWidth
            required={field.required}
            name={field.title}
            size="medium"
            label={t(capitalizeFirstLetter(field.title))}
            error={!!errors?.[field.title]}
            helperText={errors?.[field.title]?.message}
            inputProps={{ "data-testid": `auth.signup.${field.title}-input` }}
            {...register(field.title)}
          />
        );
      }
    });

  return (
    <>
      {contact && renderFields(formFields.contact, 6)}
      {oib && renderFields(formFields.oib, 12)}
      {location && <CountrySelector key={"country-selector"} countryName="country" />}
      {location && renderFields(formFields.location, 6)}
    </>
  );
}
